import * as React from 'react';
import PropTypes from "prop-types";
import {Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import Select from "react-select";
import LabelInfoTooltip from "../../LabelInfoTooltip";
import {useTranslation} from "react-i18next";

const DocumentsTypeSelect = (props) => {
  const { t } = useTranslation('supplier_create')
  const [value, setValue] = React.useState(props.value);

  const options = [
    {
      label: t('supplier.autoPartnerSa.documents_type_select.1'),
      value: 1,
    },
    {
      label: t('supplier.autoPartnerSa.documents_type_select.2'),
      value: 2,
    },
  ]

  return <Select
    menuPortalTarget={document.body}
    classNamePrefix="react-select"
    options={options}
    isDisabled={props.isDisabled}
    value={options.find(o => o.value === value)}
    placeholder={t('common:select.placeholder')}
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />
}

function SupplierElitFields(props) {
  const { t } = useTranslation('supplier_create')

  return (
    <React.Fragment>
      <FormGroup row>
        <Label md={3}>{t('supplier.elit.client_number')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientNumber?.errors} placeholder={t('supplier.elit.client_number')} onChange={e => props.onChangeData({clientNumber: e.target.value})} value={props.data.clientNumber || ''} />
          <FormFeedback>{props.errors.clientNumber?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier.elit.client_key')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientKey?.errors} placeholder={t('supplier.elit.client_key')} onChange={e => props.onChangeData({clientKey: e.target.value})} value={props.data.clientKey || ''} />
          <FormFeedback>{props.errors.clientKey?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier.elit.client_personal_key')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientPersonalKey?.errors} placeholder={t('supplier.elit.client_personal_key')} onChange={e => props.onChangeData({clientPersonalKey: e.target.value})} value={props.data.clientPersonalKey || ''} />
          <FormFeedback>{props.errors.clientPersonalKey?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>
          <span className="mr-1">{t('supplier._global.documents_type')}</span>
          <LabelInfoTooltip msg={t('supplier._global.documents_type_tooltip')} />
        </Label>
        <Col md="9">
          <DocumentsTypeSelect
            value={props.data.documentsType}
            isDisabled={!!props.data.correct}
            onChange={documentsType => props.onChangeData({documentsType})}
          />
          {props.errors.documentsType?.errors && <FormFeedback className="d-block">{props.errors.documentsType?.errors?.join('; ')}</FormFeedback>}
        </Col>
      </FormGroup>
    </React.Fragment>
  );
}

SupplierElitFields.propTypes = {
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    clientNumber: PropTypes.string,
    clientKey: PropTypes.string,
    clientPersonalKey: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplierElitFields;
